import React from "react";
import { CoreBase } from "./interfaces";
import LeftMenuTemplate from "./LeftMenuTemplate";
import PageContent from "./components/App/PageContent";
import Utils from "./helpers/utils";
interface Props {
  args: CoreBase;
  params: any;
  childrenComponents: any;
  proc: any;
  application_id: any;
}
class EOXApplication extends React.Component<Props, { cacheData: any }> {
  core: CoreBase;
  helper: any;
  params: any;
  proc: any;
  notif: any;
  pageContent: any;
  loader: any;
  
  constructor(props) {
    super(props);
    this.core = this.props.args;
    this.helper = this.core.make("oxzion/restClient");
    this.loader = this.core.make("oxzion/splash");
    this.notif = React.createRef();
    this.state = {
      cacheData: null,
    };
  }

  /**
   * Manages cache operations for the application.
   *
   * @param {string} path - The cache operation path.
   * @param {string} method - The HTTP method to be used for the cache operation.
   * @returns {Promise<any>} The cache data or result of the cache operation.
   *
   * @remarks
   * Supports three main cache operations:
   * - "cache","get": Retrieve cache data on load
   * - "storecache/{cacheId}","post": Update cache after first form submission
   * - "deletecache","delete": Clear cache after successful submission
   */

  async manageCache(path: string, method: string) {
    let url = "/app/" + this.props.application_id + "/" + path;
    let cacheData = await this.helper.request("v1", url, {}, method);
    return cacheData;
  }

  componentDidMount() {
    this.fetchInitialCache();
  }

  fetchInitialCache = async () => {
    this.loader.show();
    let cacheData = null;
    try {
      cacheData = await this.manageCache("cache", "get");
    } catch (error) {
      console.error("Error fetching initial cache:", error);
    }
    this.setState({ cacheData: cacheData?.data || cacheData }, () => this.loader.destroy());
  }

  setupPagecontent = () => [{
    type: "Form",
    form_id: this.state.cacheData?.formId,
    cacheId: this.state.cacheData?.cacheId,
    data: this.state.cacheData
  }];

  render() {
    const { cacheData } = this.state;
    if (!cacheData) return null;

    return (
      <div style={{height: "inherit"}}>
        {cacheData?.cacheId ? (
          <PageContent
            key={Math.random()}
            appId={this.props.application_id}
            core={this.core}
            params={this.props.params}
            proc={this.props.proc}
            postSubmitCallback={this.fetchInitialCache}
            pageId={Utils.generateUUID()} // generate UUID
            notif={this.notif}
            pageContent={this.setupPagecontent()}
          />
        ) : (
          <LeftMenuTemplate core={this.core} params={this.props.params} proc={this.props.proc} appId={this.props.application_id} childrenComponents={this.props.childrenComponents} />
        )}
      </div>
    );
  }
}
export default EOXApplication;
